import { z } from 'zod';

export const ConfigSchema = z.object({
  apiBaseUrl: z.string().url().or(z.string()),
  socketBaseUrl: z.string().url().or(z.string()),
  sipWsUrl: z.string(),
  sipUri: z.string(),
  apiTimeout: z.number().int().positive(),
  googleMapsApiKey: z.string(),
  // Fire / emergency
  firePhoneNumber: z.string(),
  // Operator status sync
  operatorStatusUpdateSyncInterval: z.number().int().nonnegative(),
  // Admin console iframe
  tintinAdminConsoleUrl: z.string(),
  // Dev mode (from import.meta.env.DEV)
  dev: z.boolean(),
});

export type Config = z.infer<typeof ConfigSchema>;
